import React from 'react';

import RowActionButton, {
  MenuKeyType,
} from 'commons/components/RowActionButton/RowActionButton.component';
import { BinListRowAction } from 'commons/enums';
import { IBin } from 'commons/types';

const BinListRowActionBtn: React.FC<{
  bin: IBin;
  onClickEditBinType: (bin: IBin) => void;
  onClickEditCommodity: (bin: IBin) => void;
}> = ({ bin, onClickEditBinType, onClickEditCommodity }) => {
  const [open, setOpen] = React.useState(false);

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const options: {
    label: string;
    key: BinListRowAction;
  }[] = [
    {
      label: 'Edit Bin Type',
      key: BinListRowAction.EDIT_BIN_TYPE,
    },
    {
      label: 'Edit Commodity',
      key: BinListRowAction.EDIT_COMMODITY,
    },
  ];

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleMenuClick = (menuKey: MenuKeyType) => {
    switch (menuKey) {
      case BinListRowAction.EDIT_BIN_TYPE:
        onClickEditBinType(bin);
        break;
      case BinListRowAction.EDIT_COMMODITY:
        onClickEditCommodity(bin);
        break;
      default:
    }
  };

  return (
    <RowActionButton
      open={open}
      options={options}
      handleClose={handleClose}
      handleMenuClick={handleMenuClick}
      handleToggle={handleToggle}
    />
  );
};
export default BinListRowActionBtn;
